var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	3155: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	8642: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(4848))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	103: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	173: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(567), __webpack_require__.e(932), __webpack_require__.e(203)]).then(() => (() => (__webpack_require__(5039))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@pd-ui/core",

	},
	3238: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(5306))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	},
	9903: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(402))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	},
	4683: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(9264))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "jotai",

	},
	9762: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(2389))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	9743: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(2648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.14.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	6567: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(9785))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-hook-form",

	},
	8859: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3530))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@pd-ui/icons",

	},
	932: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(5830))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-components",

	},
	9203: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(5549))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@pd-ui/icons",

	},
	628: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(932), __webpack_require__.e(284)]).then(() => (() => (__webpack_require__(4621))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@pd-ui/core",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"103": [
		103
	],
	"155": [
		3155
	],
	"178": [
		173,
		3238,
		9903,
		4683,
		9762,
		9743
	],
	"203": [
		9203
	],
	"567": [
		6567
	],
	"628": [
		628
	],
	"642": [
		8642
	],
	"859": [
		8859
	],
	"932": [
		932
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}